import { FC, HTMLAttributes } from 'react';

import { FormGroupContainer } from './styles';

type IProps = HTMLAttributes<HTMLDivElement>;

export const FormGroup: FC<IProps> = ({ children, ...props }) => {
  return <FormGroupContainer {...props}>{children}</FormGroupContainer>;
};
